import { StyleSheet } from 'react-native';
import { Colors } from 'react-native-paper';
import { pixelDimensions } from '../../../config/utils';

const styles = StyleSheet.create({
  button: {
    marginVertical: pixelDimensions(5),
    paddingVertical: pixelDimensions(2),
    paddingHorizontal: pixelDimensions(5),
  },
  image: {
    width: pixelDimensions(70),
    height: pixelDimensions(70),
  },
  textButton: {
    color: Colors.white,
    fontFamily: 'MBold',
    fontSize: pixelDimensions(5),
  },
  textTitle: {
    fontSize: pixelDimensions(8),
    fontFamily: 'MBold',
    textAlign: 'center',
    marginBottom: pixelDimensions(5),
  },
  textSubTitle: {
    fontSize: pixelDimensions(5),
    textAlign: 'center',
  },
  viewBase: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: pixelDimensions(5),
  },
});

export default styles;
